import React, { useRef } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import useVisibilitySensor from "@rooks/use-visibility-sensor";

import StarringYouClipPresenter from "presenters/StarringYouClipPresenter";
import Placeholder from "components/Placeholder";
import { appRoutes } from "routes";
import { useTemplateGroupTracking } from "hooks";

import useStyles from "./useStyles";

const StarringYouClip = ({ item, loading = false, playing = false }) => {
  const classes = useStyles();
  const clipRef = useRef(null);
  const { trackClick } = useTemplateGroupTracking(item);
  const { isVisible } = useVisibilitySensor(clipRef, {
    intervalCheck: 50,
    scrollCheck: true,
    resizeCheck: true,
    partialVisibility: false,
  });

  if (loading)
    return (
      <div className={classes.player}>
        <Placeholder variant="rect" ratio="16x9" />
      </div>
    );

  return (
    <NavLink onClick={trackClick} to={appRoutes.templateGroupPath(StarringYouClipPresenter.id(item))} ref={clipRef}>
      <div className={classes.player}>
        <ReactPlayer
          height="101%"
          width="101%"
          playing={playing && isVisible}
          loop
          muted
          playsinline
          url={StarringYouClipPresenter.animatedThumb(item)}
        />
      </div>
    </NavLink>
  );
};

StarringYouClip.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({}),
  }),
  playing: PropTypes.bool,
  loading: PropTypes.bool,
};

export default StarringYouClip;
